function decodeImg(logo) {
    if (!logo) return null;
    const base64Image = logo.split(',')[1];
    // check if it's a svg
    if (logo.startsWith('data:image/svg+xml;base64,')) {
        return <img src={`data:image/svg+xml;base64,${base64Image}`} alt="Logo" className="max-w-full h-auto" />;
    }
    // check if it's a png
    if (logo.startsWith('data:image/png;base64,')) {
        return <img src={`data:image/png;base64,${base64Image}`} alt="Logo" className="max-w-full h-auto" />;
    }
    // check if it's a jpeg
    if (logo.startsWith('data:image/jpeg;base64,')) {
    return <img src={`data:image/jpeg;base64,${base64Image}`} alt="Logo" className="max-w-full h-auto" />;
    }
    // check if it's a jpg
    if (logo.startsWith('data:image/jpg;base64,')) {
        return <img src={`data:image/jpg;base64,${base64Image}`} alt="Logo" className="max-w-full h-auto" />;
    }
    // check if it's a gif
    if (logo.startsWith('data:image/gif;base64,')) {
        return <img src={`data:image/gif;base64,${base64Image}`} alt="Logo" className="max-w-full h-auto" />;
    } else {
        return null;
    }
}

export const AUTH_STORAGE_KEY = 'bainv-auth';

export const getStoredAuthStatus = () => {
    if (typeof window === 'undefined') return false;
    return window.localStorage.getItem(AUTH_STORAGE_KEY) === 'true';
};

export const persistAuthStatus = (value) => {
    if (typeof window === 'undefined') return;
    if (value) {
        window.localStorage.setItem(AUTH_STORAGE_KEY, 'true');
    } else {
        window.localStorage.removeItem(AUTH_STORAGE_KEY);
    }
};

export const clearStoredAuthStatus = () => {
    if (typeof window === 'undefined') return;
    window.localStorage.removeItem(AUTH_STORAGE_KEY);
};

export const validateCredentials = (username, password) => {
    const expectedUsername = process.env.REACT_APP_USERNAME_KEY;
    const expectedPassword = process.env.REACT_APP_PASSWORD_KEY;
    return (
        typeof username === 'string' &&
        typeof password === 'string' &&
        username.trim() === (expectedUsername || '') &&
        password === (expectedPassword || '')
    );
};

export default decodeImg;
